export default __webpack_public_path__ + "static/media/17_tag_fitness-gym.4fd634df.svg";